/* @flow */

import api from '../api'

import type { ApiResponse, Id, Subbrand } from '../types'

export const getSubbrands = (): Promise<
  ApiResponse<{ subbrands: Array<Subbrand> }>
> => api.get('/subbrands')
